<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>家庭医生工作站</el-breadcrumb-item>
        <el-breadcrumb-item>会员管理</el-breadcrumb-item>
        <el-breadcrumb-item>健康管理方案</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>

    <el-button-group>
      <el-button class="healthButton" @click="click(0)">数字档案</el-button>
      <!-- <el-button
        class="healthButton"
        style="background-color: #ebedf0"
        @click="click(1)"
        >重大疾病风险状态
      </el-button> -->
      <el-button class="healthButton" @click="click(6)">药物方案</el-button>
      <el-button class="healthButton" @click="click(2)">健康达标报告</el-button>
      <el-button class="healthButton healthActive" @click="click(3)">健康管理方案</el-button>
      <el-button class="healthButton" @click="click(4)">行为认知治疗</el-button>
      <el-button class="healthButton" @click="click(5)">运动随访</el-button>
    </el-button-group>
    <div class="card">
      <div class="left">
        <div class="person">
          <div class="title"></div>
          <div class="img">
            <div><img src="@/page/login/images/personal.png" /></div>
          </div>
          <div class="name">{{ info.name }}</div>
          <div class="body">
            <div class="th">
              <div class="td">性别：</div>
              <div class="tr">{{ info.sex === 1 ? '男' : info.sex === 2 ? '女' : '未填写' }}</div>
            </div>
            <div class="th">
              <div class="td">手 机 号 码：</div>
              <div class="tr">{{ info.mobile }}</div>
            </div>
            <div class="th">
              <div class="td">身高 | 体重：</div>
              <div class="tr">{{ info.height ? info.height : ' ' }}cm | {{ info.weight ? info.weight : ' ' }}kg</div>
            </div>
            <div class="th">
              <div class="td">年龄 | 生日：</div>
              <div class="tr">{{ info.age }}岁 | 未填写</div>
            </div>
            <div class="th">
              <div class="td">身 份 证 号：</div>
              <div class="tr">{{ info.idCard }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="chuF">
          <div class="title">
            <div :class="chuFshow == 1 ? 'active' : ''" @click="changeChuF(1)">健康策略指导</div>
            <div :class="chuFshow == 2 ? 'active' : ''" @click="changeChuF(2)">复查检查检验</div>
            <div :class="chuFshow == 3 ? 'active' : ''" @click="changeChuF(3)">临床营养方案</div>
            <div :class="chuFshow == 4 ? 'active' : ''" @click="changeChuF(4)">运动方案</div>
            <div :class="chuFshow == 5 ? 'active' : ''" @click="changeChuF(5)">药品推荐</div>
            <div :class="chuFshow == 6 ? 'active' : ''" @click="changeChuF(6)">运动处方</div>
          </div>
          <template v-if="chuFshow == 1">
            <div class="content">
              <div class="broadcast">
                <img src="@/page/login/images/broadcast.png" />
                <div>您好，根据用户的个性化数字健康档案、动态健康数据结论、体检报告分析，用户的健康策略指导方案如下:</div>
              </div>
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">诊疗方案型策略:</div>
              </div>
              <div class="celue" style="flex-direction: column">
                {{ healthStrategy.diagnosePlan || '--' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">指标管理型策略:</div>
              </div>
              <div class="celue" style="flex-direction: column">
                {{ healthStrategy.indicatorManagement || '--' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h2"></div>
                <div class="dt">具体运动干预策略:</div>
              </div>
              <div class="celue">
                {{ healthStrategy.exerciseIntervention || '--' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h3"></div>
                <div class="dt">监测与随访型策略</div>
              </div>
              <div class="celue">
                {{ healthStrategy.monitorFollow || '--' }}
              </div>
            </div>
          </template>

          <template v-if="chuFshow == 2">
            <div class="content" v-if="review.length == 0">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">未生成复查检查检验</div>
              </div>
              <div class="celue" style="flex-direction: column">
                <br />
              </div>
            </div>

            <div class="content" v-for="(item, index) in review" :key="index">
              <div class="name">
                <div :class="['icon', 'h' + ((index % 5) + 1)]"></div>
                <div class="dt">{{ item.name }}</div>
              </div>
              <div class="celue" style="flex-direction: column">
                {{ item.time }}
                <br />
                {{ item.frequency }}
              </div>
            </div>
          </template>

          <template v-if="chuFshow == 6">
            <MotionUser></MotionUser>
          </template>

          <template v-if="chuFshow == 3">
            <Nutritional></Nutritional>
          </template>

          <template v-if="chuFshow == 5">
            <Drug v-if="false"></Drug>
            <div class="content" v-if="drugPlan.length == 0">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">未生成推荐药物</div>
              </div>
              <div class="celue" style="flex-direction: column">
                <br />
              </div>
            </div>

            <div class="content" v-for="(item, index) in drugPlan" :key="index">
              <div class="name">
                <div :class="['icon', 'h' + ((index % 5) + 1)]"></div>
                <div class="dt">{{ item.name }}</div>
              </div>
              <div class="celue" style="flex-direction: column">
                {{ item.dose }}
                <br />
                {{ item.frequency }}
                <br />
                {{ item.attention }}
              </div>
            </div>
          </template>

          <template v-if="chuFshow == 4">
            <SportsPlan></SportsPlan>
          </template>
        </div>
      </div>
    </div>
    <div class="review-panel">
      <div class="review-header">
        <div class="review-title">审核意见</div>
        <div class="review-tags">
          <el-tag
            v-for="tag in reviewTags"
            :key="tag"
            class="review-tag"
            effect="plain"
            @click="fillReviewOpinion(tag)"
          >
            {{ tag }}
          </el-tag>
        </div>
      </div>
      <div class="review-body">
        <el-input
          v-model="reviewOpinion"
          type="textarea"
          :rows="4"
          maxlength="300"
          show-word-limit
          placeholder="请输入审核意见"
        ></el-input>
        <el-button type="primary" class="review-confirm" @click="confirmReviewOpinion">确认</el-button>
      </div>
    </div>
    <!-- <div class="card-row" style="margin-bottom: 20px">
      <div class="card card01">
        <div
          class="card-row"
          style="font-size: 20px; font-weight: bold; margin-bottom: 2vh"
        >
          {{ info.name }}
        </div>
        <div class="card03" style="font-size: 14px">
          <div>
            性别：{{ info.sex === 1 ? "男" : info.sex === 2 ? "女" : "未填写" }}
          </div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card03" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>
            身高|体重：{{ info.height ? info.height : " " }}cm/{{
              info.weight ? info.weight : " "
            }}kg
          </div>
          <div>身份证号：{{ info.idCard }}</div>
        </div>
      </div>
    </div> -->

    <!-- <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :page.sync="page"
      @on-load="onLoad"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"> </template>
      <template slot-scope="scope" slot="drug">
        <el-button type="text" size="small" @click.native="toDrug(scope.row)">
          查看药品
        </el-button>
      </template>
      <template slot-scope="scope" slot="motion">
        <el-button type="text" size="small" @click.native="toMotion(scope.row)">
          查看运动处方
        </el-button>
      </template>
    </avue-crud> -->
  </basic-container>
</template>

<script>
import { getScheme, getUserJkDetail, HealthStrategy, review, drugPlan } from '@/api/health/manage'
import { mapGetters } from 'vuex'
import MotionUser from './motion'
import Drug from './drugDetails'
import Nutritional from './nutritionalPlan'
import SportsPlan from './sportsPlan'
import func from '@/util/func'

export default {
  components: {
    MotionUser,
    Drug,
    Nutritional,
    SportsPlan
  },
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      info: {},
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        column: [
          {
            label: '方案生成时间',
            prop: 'date'
            // search: true
          },
          {
            label: '药品推荐',
            prop: 'drug'
            // search: true
          },
          {
            label: '复查检查检验',
            prop: 'check'
            // search: true
          },
          {
            label: '临床营养方案',
            prop: 'nutrition',
            dicData: [
              { label: '尚未生成', value: 0 },
              { label: '已生成', value: 1 }
            ]
          },
          {
            label: '运动处方方案',
            prop: 'motion',
            dicData: [
              { label: '尚未生成', value: 0 },
              { label: '已生成', value: 1 }
            ]
          },
          {
            label: '睡眠改善方案',
            prop: 'heartRate'
          },
          {
            label: '情绪调节方案',
            prop: 'heartRate'
          }
        ]
      },
      data: [],
      chuFshow: 1,
      healthStrategy: {},
      review: [],
      drugPlan: [],
      reviewOpinion: '',
      reviewTags: ['分析逻辑合理', '趋势平稳', '已查阅', '数据有波动建议线下复诊']
    }
  },
  created() {
    this.onLoad()
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId
      console.log(wxUserId)
      getUserJkDetail(wxUserId).then(res => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377') {
          res.data.userJk.name = func.maskName(res.data.userJk.name);
          res.data.userJk.mobile = func.maskPhone(res.data.userJk.mobile);
        }
        this.info = res.data.userJk
      })
      getScheme(wxUserId).then(res => {
        this.data = res.data
      })

      HealthStrategy(this.wxUserId).then(res => {
        this.healthStrategy = res.data
      })

      review(this.wxUserId).then(res => {
        this.review = res.data
      })

      drugPlan(this.wxUserId).then(res => {
        this.drugPlan = res.data
      })
    },

    changeChuF(id) {
      this.chuFshow = id
    },

    fillReviewOpinion(tag) {
      const opinion = this.reviewOpinion.trim()
      this.reviewOpinion = opinion ? `${opinion}，${tag}` : tag
    },

    confirmReviewOpinion() {
      if (!this.reviewOpinion.trim()) {
        this.$message.warning('请输入审核意见')
        return
      }
      this.$message.success('审核意见已确认')
    },

    toDrug(row) {
      const parameter = {
        wxUserId: this.$route.query.wxUserId
      }
      this.$router.push({
        path: '/doctor/drugDetails',
        query: parameter
      })
    },

    toMotion(row) {
      console.log(this.wxUserId)
      const parameter = {
        wxUserId: this.wxUserId
      }
      this.$router.push({
        path: '/doctor/motion',
        query: parameter
      })
    },

    click(index) {
      let path = ''
      switch (index) {
        case 0:
          // path = '/doctor/digitalarchive'
          // path = '/healthmanagement/dataarchive'
          path = '/doctor/dataarchive'
          break
        case 1:
          path = '/doctor/criticalillness'
          break
        case 2:
          path = '/doctor/healthreport'
          break
        case 3:
          path = '/doctor/healthmanage'
          break
        case 4:
          path = '/doctor/cognitivebehaviorald'
          break
        case 5:
          path = '/doctor/motionFollowDetail'
          break
        case 6:
          path = '/doctor/drugDetails'
          break
      }
      const parameter = {
        wxUserId: this.wxUserId
      }
      this.$router.push({
        path: path,
        query: parameter
      })
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: '/doctor/doctorvipmanage'
      })
    }
  }
}
</script>

<style  lang="scss" scoped>
.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 10px;
}

.card {
  background: #f0f2f5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card03 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
.card {
  display: flex;
}
.review-panel {
  margin-top: 10px;
  padding: 18px 22px;
  background-color: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-sizing: border-box;
}
.review-header {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.review-title {
  flex: 0 0 auto;
  margin-right: 18px;
  color: #101010;
  font-size: 16px;
  font-weight: bold;
}
.review-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.review-tag {
  cursor: pointer;
  user-select: none;
}
.review-body {
  display: flex;
  align-items: flex-end;
  gap: 14px;
}
.review-body .el-textarea {
  flex: 1;
}
.review-confirm {
  flex: 0 0 auto;
  min-width: 92px;
  height: 40px;
}
.left {
  width: 20%;
}
.person {
  width: 100%;
  height: 50vh;
  background-color: #ffffff;
  border-radius: 12px;
  margin-top: 10px;
  .title {
    width: 100%;
    height: 26%;
    background-color: #409eff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  .img {
    width: 40%;
    height: auto;
    margin: 0 auto;
    border-radius: 12px;
    margin-top: -25%;
    background-color: #ffffff;
    display: flex;
    justify-items: center;
    justify-content: center;
    padding: 4% 0;
    div {
      width: 80%;
      background-color: #409eff;
      border-radius: 12px;
      display: flex;
      justify-items: center;
      justify-content: center;
      padding: 18% 0;
      img {
        width: 50%;
        height: auto;
      }
    }
  }
  .name {
    width: 100%;
    text-align: center;
    font-size: 28px;
    color: #101010;
    font-weight: bold;
  }
  .body {
    padding: 5%;
    height: 50%;
    .th {
      display: flex;
      width: 95%;
      font-size: 16px;
      line-height: 40px;
      .td {
        width: 40%;
      }
      .tr {
        overflow: hidden; /* 隐藏溢出内容 */
        text-overflow: ellipsis; /* 溢出时显示省略号 */
        white-space: nowrap; /* 强制文本在一行内显示 */
      }
    }
  }
}
.right {
  width: 80%;
  padding: 10px 20px;
}
.chuF {
  width: 90%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2%;
  .title {
    display: flex;
    div {
      width: 12%;
      height: 40px;
      line-height: 40px;
      border: 1px solid #666666;
      text-align: center;
      color: #666666;
      border-radius: 24px;
      margin-right: 2%;
    }
    .active {
      background-color: #409eff;
      color: #fff;
      border: none;
    }
  }
  .content {
    width: 100%;
    .name {
      height: 45px;
      padding: 10px 0;
      display: flex;
      margin-top: 10px;
      .icon {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin: 5px 10px 0 0;
      }
      .h1 {
        background-color: #409eff;
      }
      .h2 {
        background-color: #fe62e7;
      }
      .h3 {
        background-color: #ff9037;
      }
      .h4 {
        background-color: #43d87f;
      }
      .h5 {
        background-color: #bb68fc;
      }
      .dt {
        color: #0f1021;
        font-size: 16px;
      }
    }
    .celue {
      border-left: 1px solid #e6e6e6;
      padding: 0 20px;
      margin-left: 5px;
      color: #666666;
      font-size: 14px;
      line-height: 20px;
    }
    .broadcast {
      padding-top: 40px;
      display: flex;
      img {
        width: 40px;
        height: 40px;
        margin: 0 5px;
      }
      div {
        width: 90%;
        // height: 50px;
        line-height: 30px;
        font-size: 20px;
        color: #409eff;
      }
    }
  }
}
</style>
